exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonFooter__CreditInvoiceEmailModal-module___29y8S {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n}\n", ""]);

// Exports
exports.locals = {
	"buttonFooter": "buttonFooter__CreditInvoiceEmailModal-module___29y8S"
};